import React from "react";
import { useTranslation } from "react-i18next";

export const HD404 = () => {
    const {t} = useTranslation()
    return(
        <>
        <div className="contentBox">
            <div className="tabBox">
                <div className="left">
                    <h3>
                        <span>HYUNDAI ENGINE:</span>
                        HD404TA
                    </h3>
                    
                    <ul className="tabBtnBox">
                        <li className="active">{t("hyundai_8")}</li>
                        <li>{t("hyundai_9")}</li>
                    </ul>
                    {/* <!-- 탭 버튼 : 클릭시 active클래스 --> */}
                </div>
                <div className="right">
                    <div className="tabContentBox">
                        <div className="imgBox active">
                            <img src="/assets/images/hd404_view_img.png" alt="HD404TA"/>
                        </div>
                        <div className="imgBox">
                            <img src="/assets/images/hd404_view_drawing.png" alt="HD404"/>
                        </div>
                    </div>
                    {/* <!-- 탭버튼에 따라 이미지 변경 --> */}
                </div>
            </div>

            <div className="tableWrap ships">
                <table>
                    <thead>
                        <tr>
                            <th>{t("hyundai_10")}</th>
                            <th>{t("hyundai_11")}</th>
                            <th>HD404TA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>{t("hyundai_12")}</th>
                            <td></td>
                            <td>{t("hyundai_13")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_14")}(BHP)</th>
                            <td>PS(kW)/RPM</td>
                            <td>175(128)/2500</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_15")}</th>
                            <td></td>
                            <td>4</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_16")}</th>
                            <td>mm</td>
                            <td>103x118</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_17")}</th>
                            <td>cc</td>
                            <td>3,933</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_18")}</th>
                            <td></td>
                            <td>TCI</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_19")}</th>
                            <td></td>
                            <td>17.0:1</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_20")}</th>
                            <td></td>
                            <td>1-3-4-2</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_21")}</th>
                            <td></td>
                            <td>{t("hyundai_22_2")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_23")}</th>
                            <td>ℓ/hr</td>
                            <td>33.8</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_24")}</th>
                            <td>ℓ</td>
                            <td>14</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_25")}</th>
                            <td>kg/㎠</td>
                            <td>3.0~5.0</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_26")}</th>
                            <td></td>
                            <td>{t("hyundai_27")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_28")}</th>
                            <td>V-KM</td>
                            <td>24-5.5</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_29")}</th>
                            <td>V-A</td>
                            <td>24-70</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_30")}</th>
                            <td></td>
                            <td>{t("hyundai_31")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_32")}</th>
                            <td>ℓ</td>
                            <td>15</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_33")}</th>
                            <td></td>
                            <td>{t("hyundai_34")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_35")}</th>
                            <td></td>
                            <td>{t("hyundai_36_2")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_37")}</th>
                            <td>mm</td>
                            <td>1,215x750x895</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_38")}</th>
                            <td>kg</td>
                            <td>380</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_39")}</th>
                            <td></td>
                            <td>1.61, 2.06, 2.45, 2.82, 3.12, 3.46</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </>
    )
}